import { Type } from 'class-transformer';
import { ArrayUnique, IsArray, IsBoolean, IsIn, IsString, MaxLength, MinLength, ValidateNested } from 'class-validator';
import { INVOICE_STATUSES_ARRAY, InvoiceStatus } from '../enums/invoice-statuses';

export class LeadAssignmentNotificationSettingsDto {
  @IsBoolean()
  enabled: boolean;

  @IsString()
  @MinLength(1)
  @MaxLength(255)
  subject: string;

  @IsString()
  @MinLength(1)
  @MaxLength(4096)
  body: string;
}

export class InvoiceStatusNotificationSettingsDto {
  @IsBoolean()
  enabled: boolean;

  @IsArray()
  @ArrayUnique()
  @IsIn(INVOICE_STATUSES_ARRAY.map(({ id }) => id), { each: true })
  statuses: InvoiceStatus[];

  @IsString()
  @MinLength(1)
  @MaxLength(255)
  subject: string;

  @IsString()
  @MinLength(1)
  @MaxLength(4096)
  body: string;
}

export class SettingsNotificationsDto {
  @ValidateNested()
  @Type(() => LeadAssignmentNotificationSettingsDto)
  leadAssignment: LeadAssignmentNotificationSettingsDto;

  @ValidateNested()
  @Type(() => InvoiceStatusNotificationSettingsDto)
  invoiceStatusChange: InvoiceStatusNotificationSettingsDto;
}
